import get from 'lodash/get';

function defaultValue(type) {
  if (type === 'boolean') {
    return false;
  }

  if (type === 'number') {
    return 0;
  }

  return '';
}

function decodeFormType(rawType = 'text') {
  return (
    {
      phone: 'tel',
      string: 'text'
    }[rawType] || rawType
  );
}

function decodeFormField(data = {}) {
  const type = decodeFormType(get(data, 'form_field_type.name'));

  const uiSettings = get(data, 'ui_settings');
  const placeholder = get(uiSettings, 'place_holder', '');
  const size = get(uiSettings, 'size', 'full');

  return {
    id: data.id,
    key: data.key,
    name: data.key,
    label: data.label,
    options: (data.options || []).map(opt => ({
      label: opt.label,
      value: opt.id
    })),
    disabled: !!data.read_only,
    required: !!data.required,
    value: defaultValue(type),
    placeholder,
    requiredFor: data.required_for,
    size,
    type
  };
}

export default decodeFormField;
